import React from 'react'
import { URL_SRV_RAIZ } from '../router/Url';

export default function GetlogData({EMPRESA}){
  // console.log('Planta =>>>>>', PLANTA,DESDE,HASTA)
  return new Promise(async (resolve, reject) => {
    let query = await fetch(URL_SRV_RAIZ+'log_report_fracttal',{
      method: 'POST',
      headers: {
        'authorization': "marcuxo",
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        EMPRESA:EMPRESA
      }
      )
    })
    let responsito = await query.json();
    // console.log(responsito)
    if(responsito.success){
      resolve(responsito.body)

    }else{
      resolve(responsito.success)
      alert('ups!! Ocurrio un error vuelva a intentarlo mas tarde.')
    }
  })
}